import axios from 'axios';

const API_BASE = '/api/customers';

export const customerService = {
  // Get all customers with optional filters
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  // Get single customer by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  // Create new customer
  create: async (customerData) => {
    const response = await axios.post(API_BASE, customerData);
    return response.data;
  },

  // Update customer
  update: async (id, customerData) => {
    const response = await axios.put(`${API_BASE}/${id}`, customerData);
    return response.data;
  },

  // Delete customer
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  // Search customers
  search: async (query) => {
    const response = await axios.get(`${API_BASE}/search/${query}`);
    return response.data;
  }
};

export const contactService = {
  getByCustomerId: async (customerId) => {
    const response = await axios.get(`${API_BASE}/${customerId}/contacts`);
    return response.data;
  },

  create: async (customerId, contactData) => {
    const response = await axios.post(`${API_BASE}/${customerId}/contacts`, contactData);
    return response.data;
  },

  update: async (customerId, contactId, contactData) => {
    const response = await axios.put(`${API_BASE}/${customerId}/contacts/${contactId}`, contactData);
    return response.data;
  },

  delete: async (customerId, contactId) => {
    const response = await axios.delete(`${API_BASE}/${customerId}/contacts/${contactId}`);
    return response.data;
  }
};

export const addressService = {
  getByCustomerId: async (customerId) => {
    const response = await axios.get(`${API_BASE}/${customerId}/addresses`);
    return response.data;
  },

  create: async (customerId, addressData) => {
    const response = await axios.post(`${API_BASE}/${customerId}/addresses`, addressData);
    return response.data;
  },

  update: async (customerId, addressId, addressData) => {
    const response = await axios.put(`${API_BASE}/${customerId}/addresses/${addressId}`, addressData);
    return response.data;
  },

  delete: async (customerId, addressId) => {
    const response = await axios.delete(`${API_BASE}/${customerId}/addresses/${addressId}`);
    return response.data;
  }
};
